import * as Yup from "yup";

export const frameworkSchema = Yup.object({
  name: Yup.string()
    .trim()
    .min(1, "Name is required")
    .max(200)
    .required("Name is required"),
  description: Yup.string().max(1000).nullable(),
});

const DISCLOSURE_INPUT_TYPES = [
  "simple",
  "simpleLongText",
  "value",
  "valueUnit",
  "selector",
  "calculated",
];

const DISCLOSURE_CATEGORIES = [
  "General",
  "Environmental",
  "Social",
  "Governance",
];

export const disclosureSchema = Yup.object({
  code: Yup.string()
    .trim()
    .min(3, "Code must be at least 3 characters")
    .max(30)
    .matches(/^\S+$/, "Code cannot contain spaces")
    .required("Code is required"),
  title: Yup.string()
    .trim()
    .min(1, "Title is required")
    .max(500)
    .required("Title is required"),
  topic: Yup.string()
    .trim()
    .min(1, "Grouping Topic is required")
    .max(200)
    .required("Grouping Topic is required"),
  category: Yup.string()
    .oneOf(DISCLOSURE_CATEGORIES, "Invalid category")
    .required("Category is required"),
  inputType: Yup.string()
    .oneOf(DISCLOSURE_INPUT_TYPES, "Invalid input type")
    .required("Input type is required"),
  description: Yup.string().nullable(),
  unitOptions: Yup.array().of(Yup.string()),
  defaultUnit: Yup.string().nullable(),
  hasSubEntries: Yup.boolean(),
  consolidationMethod: Yup.string()
    .oneOf(["SUM", "AVERAGE", null, ""])
    .nullable(),
  temporalAggregation: Yup.string().oneOf(["CUMULATIVE", "LATEST", "AVERAGE"]),
  projectName: Yup.string().max(200).nullable(),
  projectDescription: Yup.string().max(1000).nullable(),
  baseline: Yup.number().nullable(),
  improvementDirection: Yup.number().oneOf([-1, 1, null]).nullable(),
  carbonEmissionMultiplier: Yup.number().nullable(),
  carbonEmissionMultiplierComments: Yup.string().nullable(),
  formula: Yup.string().nullable(),
});

export const DISCLOSURE_INPUT_TYPE_OPTIONS = [
  { value: "simple", label: "Short Text" },
  { value: "simpleLongText", label: "Long Text" },
  { value: "value", label: "Numeric Value" },
  { value: "valueUnit", label: "Numeric Value + Unit" },
  { value: "selector", label: "Option Selector" },
  { value: "calculated", label: "Calculated" },
];

export const DISCLOSURE_CATEGORY_OPTIONS = DISCLOSURE_CATEGORIES.map((v) => ({
  value: v,
  label: v,
}));

export const CATEGORY_META = [
  {
    key: "General",
    label: "General",
    short: "Gen",
    bg: "bg-purple-100 dark:bg-purple-900/40",
    text: "text-purple-700 dark:text-purple-300",
    gradientFrom: "from-purple-100 dark:from-purple-800/40",
  },
  {
    key: "Environmental",
    label: "Environmental",
    short: "E",
    bg: "bg-emerald-100 dark:bg-emerald-900/40",
    text: "text-emerald-700 dark:text-emerald-300",
    gradientFrom: "from-green-100 dark:from-green-800/40",
  },
  {
    key: "Social",
    label: "Social",
    short: "S",
    bg: "bg-blue-100 dark:bg-blue-900/40",
    text: "text-blue-700 dark:text-blue-300",
    gradientFrom: "from-blue-100 dark:from-blue-800/40",
  },
  {
    key: "Governance",
    label: "Governance",
    short: "G",
    bg: "bg-amber-100 dark:bg-amber-900/40",
    text: "text-amber-700 dark:text-amber-300",
    gradientFrom: "from-amber-100 dark:from-amber-800/40",
  },
  {
    key: "Other",
    label: "Other",
    short: "O",
    bg: "bg-slate-100 dark:bg-slate-800/40",
    text: "text-slate-700 dark:text-slate-300",
    gradientFrom: "from-slate-100 dark:from-slate-800/40",
  },
];
